import type { Map, FilterSpecification } from 'mapbox-gl'

export const updateRestrictionPointLayer = (
  map: Map,
  layerId: string,
  source: string,
  color: string,
  enabled: boolean,
  opacity: number,
  hiddenFilter: FilterSpecification | null
) => {
  const id = `${layerId}-points`
  const points: FilterSpecification = ['==', ['geometry-type'], 'Point']
  const filter: FilterSpecification = hiddenFilter
    ? ['all', points, hiddenFilter]
    : points
  if (!map.getLayer(id)) {
    map.addLayer({
      id,
      type: 'circle',
      source,
      filter,
      layout: { visibility: enabled ? 'visible' : 'none' },
      paint: {
        'circle-radius': 6,
        'circle-color': color,
        'circle-opacity': opacity,
        'circle-stroke-color': color,
        'circle-stroke-width': 2,
      },
    })
  } else {
    map.setFilter(id, filter)
    map.setLayoutProperty(id, 'visibility', enabled ? 'visible' : 'none')
    map.setPaintProperty(id, 'circle-opacity', opacity)
  }
}
